<template>
<div>
  <div v-if="state === true || state === 'true' || state == 'yes'" class="greendot"></div>
  <div v-else class="reddot"></div>
</div>
</template>

<script>
export default {
  props: ['state']
}
</script>

<style scoped>
.greendot {
  height: 10px;
  width: 10px;
  background-color: lightgreen;
  border-radius: 50%;
  display: inline-block;
}
.reddot {
  height: 10px;
  width: 10px;
  background-color: rgb(241, 45, 45);
  border-radius: 50%;
  display: inline-block;
}
</style>
